import { useEffect, useRef } from 'react';
import type { Map as MapboxMap } from 'mapbox-gl';
import type { MapStyle } from '../MapControlsFAB';
import { useMapStore } from '../../../stores/mapStore';
import { attachCoordalCatalogIcons, iconThemeForMapStyle } from './attachCoordalCatalogIcons';

/**
 * Load Coordal SVG catalog icons for POI and landmark layers (runtime addImage).
 * Sprite-sheet layers (transport, traffic, structure gates) are defined in the style JSON.
 */
export function useCoordalCatalogIcons(
  mapRef: React.MutableRefObject<MapboxMap | null>,
  mapStyle: MapStyle = 'standard',
) {
  const { isMapLoaded } = useMapStore();
  const iconTheme = iconThemeForMapStyle(mapStyle);
  const iconThemeRef = useRef(iconTheme);
  iconThemeRef.current = iconTheme;

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !isMapLoaded) return;

    return attachCoordalCatalogIcons(map, () => mapRef.current, iconThemeRef.current);
  }, [mapRef, isMapLoaded, iconTheme]);
}
